module.exports = __webpack_public_path__ + "img/fernandapinilla.d97bb8ed.jpg";